import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from '../pages/admin/Login';
import HomePage from '../pages/admin/Home';
import AkunPage from '../pages/admin/Akun';
import GrafikPage from '../pages/admin/Grafik';
import RiwayatPage from '../pages/admin/Riwayat';
import UserPage from '../pages/admin/User';
import LokasiPage from '../pages/admin/Lokasi';
import NotFoundPage from '../pages/admin/NotFound';

const Admin = () => {
  return (
    <>
      <Routes>
        <Route
          index={true}
          element={<Navigate to='/admin/home' />}
        />
        <Route
          path='/login'
          element={<LoginPage />}
        />
        <Route
          path='/home'
          element={<HomePage />}
        />
        <Route
          path='/grafik'
          element={<GrafikPage />}
        />
        <Route
          path='/akun'
          element={<AkunPage />}
        />
        <Route
          path='/riwayat'
          element={<RiwayatPage />}
        />
        <Route
          path='/user'
          element={<UserPage />}
        />
        <Route
          path='/lokasi'
          element={<LokasiPage />}
        />
        <Route
          path='/*'
          element={<NotFoundPage />}
        />
      </Routes>
    </>
  );
};

export default Admin;
